module.exports = __webpack_public_path__ + "static/img/coimg1.a440187.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/coimg1.jpg
// module id = s7F4
// module chunks = 2